import { render } from "./ApprovalFormHistoryPageList.vue?vue&type=template&id=ad75f7fa&scoped=true"
import script from "./ApprovalFormHistoryPageList.vue?vue&type=script&lang=ts"
export * from "./ApprovalFormHistoryPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-ad75f7fa"

export default script